import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {PageableUserRequest} from '../model/pageableRequest';
import {UserData} from '../model/user-data';
import {UserService} from '../service/user.service';
import {UpdateUserStatusRequest} from '../model/updateUserStatus';
import {AddUserComponent} from './adduser/add-user.component';
import {EditUserComponent} from './edituser/edit-user.component';
import {RoleCount} from '../model/roleCount';
import {LocalStorageService} from 'ngx-webstorage';
import {NotificationService} from '../service/notification.service';

@Component({
  selector: 'app-iamportal',
  templateUrl: './iamportal.component.html',
  styleUrls: ['./iamportal.component.scss']
})
export class IamportalComponent implements OnInit {
  userData: UserData = new UserData();
  userDataList: UserData[];
  roleCountList: RoleCount[];
  dataSource: MatTableDataSource<UserData>;
  isActive: Boolean = true;
  disabled: Boolean = false;
  searchKeys = [
    { id: 0, name: "SCHEDULER" },
    { id: 1, name: "SCHEDULER_MANAGER" },
    { id: 2, name: "NURSE_PRACTITIONER" },
    { id: 3, name: "CLINICAL_REVIEWER" },
    { id: 4, name: "CODER_LEVEL_1" },
    { id: 5, name: "CODER_LEVEL_2" },
    { id: 6, name: "CODING_MANAGER" },
    { id: 7, name: "IAM_ADMINISTRATOR" },
    { id: 8, name: "TELEVISIT_MANAGER" },
    { id: 9, name: "MEDIGENCE_EXECUTIVE" },
    { id: 11, name: "SALES" },
    { id: 12, name: "SALES_ADMIN" }
  ];
  selectedRole: string = "";
  searchKey: string = "";
  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  length: number;
  pageSizeOptions: number[] = [15, 30, 45];
  pageableUserRequest: PageableUserRequest = new PageableUserRequest();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<UserData>;

  displayedColumns = ['userid', 'employeeId', 'fullName', 'email', 'lastLogin', 'lastLoginIP', 'effectiveDate', 'terminationDate', 'edituser', 'userstatus'];
  constructor(public dialog: MatDialog,
    private userService: UserService,
    private _formBuilder: FormBuilder,
    private _localStorage: LocalStorageService,
    private _notificationService: NotificationService,
  ) { }
  ngOnInit() {
    this._localStorage.store('PageEvent', undefined);
    this.initRoleCount();
    this.getUsersList();
    this.getRoleCounts();
  }

  openAddUserDialog(): void {
    const dialogRef = this.dialog.open(AddUserComponent, {
      width: '750px',
      height: '400px',
      data:
        this.dialog
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("result " + result);
      this.getUsersList(this._localStorage.retrieve('PageEvent'));
      this.getRoleCounts();
    });
  }

  openEditUserDialog(event, user: UserData): void {
    this.userData = user;
    console.log("in openEditUserDialog...userData is ....:  : " + this.userData.email + ": :" + this.userData.firstName);
    const dialogRef = this.dialog.open(EditUserComponent, {
      width: '750px',
      height: '400px',
      data: this.userData
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("result " + result);
      this.getUsersList(this._localStorage.retrieve('PageEvent'));
      this.getRoleCounts();
    });
  }

  getUsersList(event?: PageEvent, clearPagination?: boolean) {
    if(clearPagination){
      this._localStorage.store('PageEvent', undefined);
    }
    if (event != undefined) {
      this._localStorage.store('PageEvent', event);
      this.pageableUserRequest.page = event.pageIndex;
      this.pageableUserRequest.size = event.pageSize;
    } else if (event === undefined || event === null) {
      this.pageableUserRequest.page = 0;
      this.pageableUserRequest.size = 15;
    }
    this.pageableUserRequest.sortBy = "firstName";
    this.pageableUserRequest.sortDir = "ASC";
    if (this.selectedRole != undefined && this.selectedRole != null) {
      this.pageableUserRequest.role = this.selectedRole.toLowerCase();
    }
    if (this.searchKey != undefined && this.searchKey != null) {
      this.pageableUserRequest.key = this.searchKey;
    }
    this.userService.getUsersList(this.pageableUserRequest).subscribe(result =>{
      if(!result)
      {
        return ;
      }
      this.userDataList = result.users;
      this.dataSource = new MatTableDataSource(result.users);
      this.dataSource.sort = this.sort;
      if (event != undefined) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.length = result.totalUsers;
      }
      if (event === undefined || event === null) {
        this.pageIndex = 0;
        this.pageSize = 15;
        this.length = result.totalUsers;
      }
    }, error => console.log(error));
    return event;
  }

  onSearchClear() {
    this.searchKey = "";
    this.getUsersList();
  }

  updateUserStatus(event, user: UserData) {
    this.disabled = !user.isActive;
    console.log(user.firstName + '>>>>>' + this.disabled)
    let updateUserStatus = new UpdateUserStatusRequest();
    updateUserStatus.userId = user.userId;
    updateUserStatus.status = this.disabled;
    updateUserStatus.updatedBy = this._localStorage.retrieve('profile').displayName;
    this.userService.updateUserStatus(updateUserStatus).subscribe(
      response => {
        console.log(response);
        this._notificationService.success('User Status Updated successfully');
        this.getUsersList(this._localStorage.retrieve('PageEvent'));
      });
  }

  onRoleChange({ value }) {
    console.log('Role changed...');
    this.searchKey = "";
    if (value === 'All') {
      this.selectedRole = "";
      this.getUsersList();
    } else {
      this.selectedRole = value;
      this._localStorage.store('PageEvent', undefined);
      this.getUsersList();
    }
  }

  getRoleCounts() {
    this.userService.getRoleCounts().subscribe(
      result => {
        if (!result) {
          return;
        }
        this.roleCountList = result.roles;
      })
  }

  initRoleCount() {
    this.roleCountList = [{
      "count": 0,
      "name": "SCHEDULER"
    },
    {
      "count": 0,
      "name": "SCHEDULER_MANAGER"
    },
    {
      "count": 0,
      "name": "NURSE_PRACTITIONER"
    },
    {
      "count": 0,
      "name": "CODING_MANAGER"
    },
    {
      "count": 0,
      "name": "CLINICAL_REVIEWER"
    },
    {
      "count": 0,
      "name": "CODER_LEVEL_1"
    },
    {
      "count": 0,
      "name": "CODER_LEVEL_2"
    },
    {
      "count": 0,
      "name": "IAM_ADMINISTRATOR"
    },
    {
      "count": 0,
      "name": "TELEVISIT_MANAGER"
    },
    {
      "count": 0,
      "name": "MEDIGENCE_EXECUTIVE"
    }]
  }
}
